import { useState } from 'react';
import screenfull from 'screenfull';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

var noop = function noop() {};

var useFullscreen = function useFullscreen(ref, on, options) {
  if (options === void 0) {
    options = {};
  }

  var video = options.video,
      _a = options.onClose,
      onClose = _a === void 0 ? noop : _a;

  var _b = useState(on),
      isFullscreen = _b[0],
      setIsFullscreen = _b[1];

  useIsomorphicLayoutEffect(function () {
    if (!on) {
      return;
    }

    if (!ref.current) {
      return;
    }

    var onWebkitEndFullscreen = function onWebkitEndFullscreen() {
      video.current.removeEventListener('webkitendfullscreen', onWebkitEndFullscreen);
      onClose();
    };

    var onChange = function onChange() {
      if (screenfull.isEnabled) {
        var isScreenfullFullscreen = screenfull.isFullscreen;
        setIsFullscreen(isScreenfullFullscreen);

        if (!isScreenfullFullscreen) {
          onClose();
        }
      }
    };

    if (screenfull.isEnabled) {
      try {
        screenfull.request(ref.current);
        setIsFullscreen(true);
      } catch (error) {
        onClose(error);
        setIsFullscreen(false);
      }

      screenfull.on('change', onChange);
    } else if (video && video.current && video.current.webkitEnterFullscreen) {
      video.current.webkitEnterFullscreen();
      video.current.addEventListener('webkitendfullscreen', onWebkitEndFullscreen);
      setIsFullscreen(true);
    } else {
      onClose();
      setIsFullscreen(false);
    }

    return function () {
      setIsFullscreen(false);

      if (screenfull.isEnabled) {
        try {
          screenfull.off('change', onChange);
          screenfull.exit();
        } catch (_a) {}
      } else if (video && video.current && video.current.webkitExitFullscreen) {
        video.current.removeEventListener('webkitendfullscreen', onWebkitEndFullscreen);
        video.current.webkitExitFullscreen();
      }
    };
  }, [on, video, ref]);
  return isFullscreen;
};

export default useFullscreen;